import { InlineIcon } from '@iconify/react';
import { FC } from 'react';
import PoHistoryWizard from 'src/components/PoHistoryWizard';
import useBoolean from 'src/hooks/useBoolean';
import Button from './design-system/Button';
import Dialog from './design-system/Dialog';
interface PoHistoryProps {
  title: string;
}

const PoHistory: FC<PoHistoryProps> = ({ title }) => {
  const { value: open, setTrue: handleOpen, setFalse: handleClose } = useBoolean();

  return (
    <>
      <Button
        color="secondary"
        startIcon={<InlineIcon icon="material-symbols:history-rounded" />}
        onClick={handleOpen}
      >
        History
      </Button>
      <Dialog
        onClose={handleClose}
        open={open}
        title={`${title} Details History`}
        width="80%"
        id="modal"
      >
        <PoHistoryWizard onClose={handleClose} />
      </Dialog>
    </>
  );
};

export default PoHistory;
